module.exports = __webpack_public_path__ + "src/img/zalando/img-big.12cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-big.jpg
// module id = 121
// module chunks = 0